import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, HostListener, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

import { ButtonComponent } from '@app/ui/components/button/button.component';

import type { ConfigConfirmDialog } from './config';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  standalone: true,
  imports: [ButtonComponent, TranslatePipe, NgClass, MatIcon, NgTemplateOutlet],
})
export class ConfirmDialogComponent {
  readonly data = inject<ConfigConfirmDialog>(MAT_DIALOG_DATA);
  readonly #mdDialogRef = inject<MatDialogRef<ConfirmDialogComponent>>(MatDialogRef<ConfirmDialogComponent>);

  readonly confirmClasses: string[] = this.data.confirmClasses ?? [];
  readonly cancelClasses: string[] = this.data.cancelClasses ?? [];
  readonly titleClasses: string[] = this.data.titleClasses ?? [];
  readonly messageClasses: string[] = this.data.messageClasses ?? [];

  cancel(): void {
    this.close(false);
  }

  close(value: boolean): void {
    this.#mdDialogRef.close(value);
  }

  confirm(): void {
    this.close(true);
  }

  @HostListener('keydown.esc')
  onEsc(): void {
    this.close(false);
  }
}
